<div class="login-container">
    <div class="login-div">
        <form role="form" (submit)="login()">
            <div class="logo">
                <img src="assets/img/my-remedi-logo-login.png">
            </div>
            <div class="form-container" [hidden]="!showPrompt">
                <div>
                    <h1>
                        Log in to MyRemedi
                    </h1>
                </div>
                <div class="alert-success" *ngIf="successMessages">
                    <div *ngFor="let message of successMessages">{{message}}</div>
                </div>
                <div class="alert alert-danger" *ngIf="errorMessages">
                    <div *ngFor="let message of errorMessages">{{message}}</div>
                </div>
                <div class="alert-warning" *ngIf="warningMessages">
                    <div *ngFor="let message of warningMessages">{{message}}</div>
                </div>
                <div class="form-row">
                    <div class="form-group">
                        <label for="username">Username </label>
                        <input type="text" maxlength="100" class="form-control" id="username" name="username"
                               [(ngModel)]="username">
                    </div>
                    <div class="form-group">
                        <label for="password">Password </label>
                        <input type="password" maxlength="100" class="form-control" id="password" name="password"
                               [(ngModel)]="password">
                    </div>
                    <div class="button-row">
                        <div class="other-actions">
                            <a (click)="navigate()">Remedi Employee Login</a>
                            <button type="submit" class="btn btn-primary" [disabled]="loginSubmitted">
                                {{loginSubmitted ? "Logging in..." : "Log in"}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>